import { useDispatch, useSelector } from 'react-redux';

import GlobalPortal from 'components/commons/GlobalPortal';
import { BulkReportsExportResultModal } from 'components/modals/BulkReportsExportResultModal';
import { reportListActions, reportListSelectors } from 'modules/reports/list';

export const GlobalModalContainer = () => {
  const dispatch = useDispatch();

  const isBulkReportsExportResultModalVisible = useSelector(reportListSelectors.isBulkReportsExportResultModalVisible);
  const bulkReportsExportResultModalData = useSelector(reportListSelectors.bulkReportsExportResultModalData);
  return (
    <GlobalPortal>
      {isBulkReportsExportResultModalVisible && bulkReportsExportResultModalData && (
        <BulkReportsExportResultModal
          data={bulkReportsExportResultModalData}
          onConfirmClick={() => dispatch(reportListActions.hideBulkReportsExportResultModal())}
        />
      )}
    </GlobalPortal>
  );
};
